module.exports = __webpack_public_path__ + "static/media/bg_11.6c7e3c28.png";